import { render, staticRenderFns } from "./BasicTreeMap.vue?vue&type=template&id=0fecce0c&scoped=true"
import script from "./BasicTreeMap.vue?vue&type=script&lang=ts"
export * from "./BasicTreeMap.vue?vue&type=script&lang=ts"
import style0 from "./BasicTreeMap.vue?vue&type=style&index=0&id=0fecce0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fecce0c",
  null
  
)

export default component.exports